<script>
export default {
  name: 'PauseSceneLoggedIn',
  props: {
    user: {
      // required: true,
      default: () => ({
        avatar: '',
        name: '1234',
      }),
    },
  },
};
</script>

<template lang="pug">
div.pause-scene-logged-in.tc
  div.avatarwrap.relative.mb2.w2.h2.center
    icon.avataricon.ma2.z-1.absolute.absolute--fill.fill-white.w1(name="singleplayer")
    img.avatar.br-100.bg-silver.w2.h2.db()
  h6.username.f7.white.mb2.fw6 1234
  link-style
    button.logoutbtn.f7(type="button") log out
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";

.pause-scene-logged-in {

}
</style>
